import React from 'react';

const Tip: React.FC<{ text: string }> = ({ text }) => (
  <span className="info-tip">
    ?
    <span className="tip-text">{text}</span>
  </span>
);

export default Tip;
